export default "__VITE_ASSET__QgnuNLCB__"